import { Component } from '@angular/core';
import { IzzyScopeEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Scopes') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzyscope-form',
    templateUrl: './izzyscope.form.component.html'
})
export class IzzyScopeFormComponent extends BaseFormComponent {
    public record!: IzzyScopeEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'scopeDetails', sectionName: 'Scope Details', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

